import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@auth0/auth0-angular';
import { DictionaryGlobalStore } from 'src/app/dictionary/store/dictionary-global.store';
import { SdProgressBarA11yComponent } from '../../../../../../../shared/sd-progress-bar-a11y/components/sd-progress-bar-a11y/sd-progress-bar-a11y.component';
import { PlatformService } from '../../../../services/platform.service';
import { SetPlatform } from 'src/app/core/store/core.actions';
import { PlatformType } from '../../../../models/platform-type.enum.model';
import { IonRouterOutlet } from '@ionic/angular/standalone';

@Component({
  selector: 'app-mobile-core-template',
  // NOTE: <ion-router-outlet> stays always mounted to avoid race conditions with
  // mobile client's lazy routes. The progress bar is rendered on top while the
  // dictionary is still loading, without replacing the outlet.
  template: `
    @if (dictionary() === null) {
      <app-sd-progress-bar-a11y progressBarType="main" />
    }
    <ion-router-outlet></ion-router-outlet>
  `,
  styleUrls: ['./mobile-core-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SdProgressBarA11yComponent, IonRouterOutlet],
})
export class MobileCoreTemplateComponent implements OnInit {
  private readonly platformService = inject(PlatformService);
  private readonly store = inject(Store<AppState>);
  private readonly dictStore = inject(DictionaryGlobalStore);
  protected readonly dictionary = this.dictStore.dictionary;

  ngOnInit(): void {
    const platform = this.platformService.getPlatform();
    this.store.dispatch(new SetPlatform({ platform }));
    if (platform === PlatformType.iOS) {
      document.body.classList.add('ios');
      return;
    }
    if (platform === PlatformType.Android) {
      document.body.classList.add('android');
    }
  }
}
